<template>
    <div class="menu_orders__list_item" :class="classItem" @click.prevent="clickOrder">
        <div class="menu_orders__list_item_content">
            <div class="menu_orders__list_item_content_info">
                <div ref="svgContainer" class="menu_orders__list_item_content_info_logo">
                </div>
                <div class="menu_orders__list_item_content_info_details">
                    <div class="menu_orders__list_item_content_info_details_client">
                        {{ clientName }}
                    </div>
                    <div class="menu_orders__list_item_content_info_details_block">
                        <div class="menu_orders__list_item_content_info_details_block_info">
                            <div class="menu_orders__list_item_content_info_details_block_info_order">
                                <div class="menu_orders__list_item_content_info_details_block_info_order_number">
                                    {{ orderCode }}
                                </div>
                                <div class="menu_orders__list_item_content_info_details_block_info_order_summ">
                                    {{ orderSum }}
                                </div>
                            </div>
                            <div class="menu_orders__list_item_content_info_details_block_info_img_block">
                                <div v-if="!isMarket"
                                     class="menu_orders__list_item_content_info_details_block_info_img_block_img">
                                    <svg>
                                        <use xlink:href="/icons/base.svg#people"></use>
                                    </svg>
                                </div>
                                <div v-if="isPayCache"
                                     class="menu_orders__list_item_content_info_details_block_info_img_block_img">
                                    <svg>
                                        <use xlink:href="/icons/base.svg#money"></use>
                                    </svg>
                                </div>
                                <div class="menu_orders__list_item_content_info_details_block_info_img_block_date_text">
                                    {{ dateOrder }}
                                </div>
                            </div>
                        </div>
                        <div class="menu_orders__list_item_content_info_details_block_state_new" v-if="isStateOrder">
                            <div class="menu_orders__list_item_content_info_details_block_state_new_text">
                                {{ __t(stateOrder) }}
                            </div>
                        </div>
                        <div class="menu_orders__list_item_content_info_details_block_state_time"
                             v-if="isOrderInProgress">
                            <span
                                class="menu_orders__list_item_content_info_details_block_state_time_text">min</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import insertSvg from "../../../mixins/insertSvg";
import formatNumber from "../../../mixins/formatNumber";
import {createHelpers} from "vuex-map-fields";
const {mapFields: mOrders} = createHelpers({
    getterType: 'orders/getOrdersField',
    mutationType: 'orders/updateOrdersField',
})

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})

export default {
    name: "menu_orders_item",
    props: {
        orderItem: {
            type: Object,
            required: true,
        },
    },
    emits: [],
    components: {},
    mixins: [insertSvg, formatNumber],
    data() {
        return {}
    },
    mounted() {
        if (this.orderItem.aggregator && this.orderItem.aggregator.icon) {
            this.insertSvg(this.orderItem.aggregator.icon);
        }
    },
    methods: {
        clickOrder() {
            EventBus.$emit('click_item_order_menu', this.orderItem);
        }
    },
    computed: {
        ...mUser([
            'user',
        ]),
        ...mOrders([
            'activeItemMenuOrders',
        ]),
        classItem() {
            let classOrderItem = {
                'active': false,
                'error': false,
            }
            if (this.orderItem.id && this.activeItemMenuOrders && this.activeItemMenuOrders.id && this.orderItem.id === this.activeItemMenuOrders.id) {
                classOrderItem.active = true;
            }
            if (this.orderItem.pos_send_status && this.orderItem.pos_send_status === 'error') {
                classOrderItem.error = true;
            }
            return classOrderItem;
        },
        clientName() {
            if (this.orderItem && this.getObjectPathProperty(this.orderItem, 'location.title')) {
                return this.orderItem.location.title;
            }
            return 'No name location';
        },
        orderCode() {
            if (this.orderItem.order_code) {
                return this.orderItem.order_code;
            }
            return 'No code order'
        },
        orderSum() {
            if (this.orderItem.price && this.user.currency_suffix && this.user.locale) {
                return this.toCurrency(this.orderItem.price, this.user.currency_suffix, 'uk-UA', 2);
            }
            return this.toCurrency(this.orderItem.price, '');
        },
        isOrderInProgress() {
            return this.orderItem.typeOrder === 'inProgress';
        },
        isStateOrder() {
            return this.orderItem.typeOrder === 'new' && this.orderItem.pos_send_status
        },
        stateOrder() {
            if (this.orderItem.pos_send_status) {
                return this.orderItem.pos_send_status;
            }
            return '';
        },
        isMarket() {
            return this.orderItem.is_market;
        },
        isPayCache() {
            return this.orderItem.is_pay_cache;
        },
        dateOrder() {
            if (this.orderItem.order && this.orderItem.order.added) {
                return this.orderItem.order.added;
            }
            return '';
        },
    },
}
</script>
